import { render, staticRenderFns } from "./Semiconductor.vue?vue&type=template&id=8547eeee&scoped=true"
import script from "./Semiconductor.vue?vue&type=script&lang=js"
export * from "./Semiconductor.vue?vue&type=script&lang=js"
import style0 from "./Semiconductor.vue?vue&type=style&index=0&id=8547eeee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8547eeee",
  null
  
)

export default component.exports